<template>
	<div class="d-none d-lg-block py-1" id="navbar-navigation-content">
		<div class="container-menu">
			<b-navbar toggleable="lg" class="nav-navigation">
				<b-navbar-nav class="d-flex justify-content-between w-100">
					<li  :style="url == 'pg1' ? 'background: #df9234; color:#fff; margin-left: 100px; width:7%;' : 'margin-left: 100px'">
						<a href="/eres-capacitador#pg1" class="nav-link p-0 m-0"  @click="url = 'pg1'">
							<span :style="url == 'pg1' ? 'color:#fff; font-size:13px;': ' font-size:13px;'">HOME</span>
						</a>
					</li>
					<li :style="url == 'pg6' ? 'background: #df9234; color:#fff;  width:7%;' : ''">
						<a href="/eres-capacitador#pg6" class="nav-link p-0 m-0"  @click="url = 'pg6'">
							<span :style="url == 'pg6' ? 'color:#fff; font-size:13px;': ' font-size:13px;'">MATCH</span>
						</a>
					</li>
					<li :style="url == 'pg2' ? 'background: #df9234; color:#fff;  width:11%;' : ''">
						<a href="/eres-capacitador#pg2" class="nav-link p-0 m-0" @click="url = 'pg2'">
							<span :style="url == 'pg2' ? 'color:#fff; font-size:13px;': ' font-size:13px;'">PUBLICAR CURSOS</span>
						</a>
					</li>
					<li :style="url == 'pg3' ? 'background: #df9234; color:#fff;  width:14%;' : ''">
						<a href="/eres-capacitador#pg3" class="nav-link p-0 m-0" @click="url = 'pg3'">
							<span :style="url == 'pg3' ? 'color:#fff; font-size:13px;': ' font-size:13px;'">CURSOS MÁS POPULARES</span>
						</a>
					</li>
<!--					<li>-->
<!--						<a href="/eres-capacitador#pg4" class="nav-link p-0 m-0">-->
<!--							CONTRATA TU MEMBRESIA-->
<!--						</a>-->
<!--					</li>-->
					<li :style="url == 'pg5' ? 'background: #df9234; color:#fff;  width:7%;' : ''">
						<a href="/eres-capacitador#pg5" class="nav-link p-0 m-0" @click="url = 'pg5'">
							<span :style="url == 'pg5' ? 'color:#fff; font-size:13px;': ' font-size:13px;'">BLOG</span>
						</a>
					</li>
					<!-- <li>
						<a href="/eres-capacitador#pg5" class="nav-link p-0 m-0">
							BLOG
						</a>
					</li> -->
				</b-navbar-nav>
			</b-navbar>
		</div>
	</div>
</template>

<script>
export default {
	name: "menu_capacitador",
	data() {
		return {
			url:"pg1"
		}
	}
}
</script>

<style scoped>
#navbar-navigation-content{
	background-color: white;
	width: 100%;
	border-bottom: 1px solid lightgray;
}
.router-link-exact-active{
	box-shadow: none !important;
	border: none !important;
}
a.nav-link.router-link-exact-active.router-link-active{
	color: #ed8f00 !important;
}
.container-menu{
	margin: 0 5.5vw;
	/*margin: 0 5.5vw 0 10.6vw;*/
}
</style>



// WEBPACK FOOTER //
// src/components/landing/menu_capacitador.vue